import React, {useState, useEffect, useContext} from 'react';
import moment from 'moment';

import {AppContext} from '../../../../AppModule/Context';

import ArrowIcon from '../../../../assets/svgComponents/Arrow';
import ButtonComponent from '../../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import ClientBookingOptionRow from './clientBookingOptionRow';
import DatePickerComponent from '../../datePicker/datePickerComponent';
import TimePickerComponent from '../../datePicker/timePickerComponent';
import TimeZonePicker from '../../datePicker/timeZonePicker';
import WidgetTitleComponent from '../../../widgetComponent/openWidgetComponent/widgetTitleComponent';

import scheduleUtils from '../../scheduleUtils';
import SessionPriceComponent from '../../../common/genericComponents/sessionPriceComponent/sessionPriceComponent';

import VIDABOO_CONSTANTS from '../../../../config/consts';

import './schedulingInWidgetStep1.css';
import utilsService from '../../../../services/utilsService';

const S1_STATES = {
  DATE: 'DATE',
  TIME: 'TIME',
  APPROVE: 'APPROVE',
};
const SchedulingInWidgetStep1 = (props) => {
  const context = useContext(AppContext);
  const [minDate, setMinDate] = useState(moment());
  const [s1State, setS1State] = useState(
    props.finishedStep1
      ? props.mentor.mentorDto.scheduleSettingsDto.autoMentorApproval
        ? S1_STATES.TIME
        : S1_STATES.APPROVE
      : S1_STATES.DATE,
  );
  const [bookingRowIndForEditDelete, setBookingRowIndForEditDelete] =
    useState(-1);
  const [bookingOptionIndex, setBookingOptionIndex] = useState(0);
  const [firstAvailableTimeSlot, setfirstAvailableTimeSlot] = useState(null);
  useEffect(() => {
    const {minTimeBeforeBooking} = props.mentor.mentorDto.scheduleSettingsDto;
    const minDate = scheduleUtils.getMinDate(
      minTimeBeforeBooking,
      props.selectedTimezone,
    );
    setMinDate(minDate);
  }, []);

  const popupDatePicker = (index) => {
    setBookingRowIndForEditDelete(-1);
    setS1State(S1_STATES.DATE);
    setBookingOptionIndex(index);
  };
  // const popupTimePicker = (index) => {
  //   setS1State(S1_STATES.TIME);
  //   setBookingOptionIndex(index);
  // };
  const selectTimeZone = (event) => {
    const selectedTimezone = event.target.value;
    // const selectedTimeZone = selected.utc[0];
    props.setSelectedTimezone(selectedTimezone);
  };
  const addBookingOption = () => {
    if (props.bookingOptions?.length < 3) {
      props.addBookingOption();
      setS1State(S1_STATES.DATE);
      setBookingOptionIndex(bookingOptionIndex + 1);
    }
  };
  const deleteBookingOption = (index) => {
    setBookingRowIndForEditDelete(-1);
    setBookingOptionIndex(bookingOptionIndex - 1);
    props.deleteBookingOption(index);
  };

  const onMonthChange = (date) => {
    const currentMonthStartDate = moment()
      .tz(props.selectedTimezone)
      .startOf('month')
      .startOf('day')
      .valueOf();

    const startOfMonthDate = moment
      .tz(date, 'MMM YYYY', props.selectedTimezone)
      .startOf('month')
      .startOf('day')
      .valueOf();

    if (props.mentor.mentorDto.scheduleSettingsDto.autoMentorApproval) {
      if (currentMonthStartDate <= startOfMonthDate) {
        const endOfMonthDate = moment(date, 'MMM YYYY')
          .endOf('month')
          .endOf('day')
          .valueOf();
        props.setAlreadyBookedTimeRanges(startOfMonthDate, endOfMonthDate);
      } else if (props.generateMentorAvailabilityListForMonth) {
        props.generateMentorAvailabilityListForMonth(
          startOfMonthDate,
          false,
          true,
        );
      }
    } else {
      props.generateMentorAvailabilityListForMonth(
        startOfMonthDate,
        false,
        true,
      );
    }
  };
  const onDateChanged = (date) => {
    const bookingOption = props.bookingOptions[bookingOptionIndex];
    const rangeStartTimeSender = moment(bookingOption.rangeStartTimeSender)
      .tz(props.selectedTimezone)
      .set({
        year: date.getFullYear(),
        month: date.getMonth(),
        date: date.getDate(),
      });
    bookingOption.rangeStartTimeSender = rangeStartTimeSender.valueOf();
    props.updateBookingOptionForDate(bookingOptionIndex, bookingOption);
  };
  const setBookingOptionDate = (date) => {
    if (props.isDemo) return;
    const bookingOption = props.bookingOptions[bookingOptionIndex];
    const rangeStartTimeSender = moment(bookingOption.rangeStartTimeSender)
      .tz(props.selectedTimezone)
      .set({
        year: date.getFullYear(),
        month: date.getMonth(),
        date: date.getDate(),
      });
    bookingOption.rangeStartTimeSender = rangeStartTimeSender.valueOf();
    props.updateBookingOptionForDate(bookingOptionIndex, bookingOption);
    setS1State(S1_STATES.TIME);
  };
  const setBookingOptionTime = (date) => {
    const bookingOption = props.bookingOptions[bookingOptionIndex];
    const rangeStartTimeSender = moment(bookingOption.rangeStartTimeSender)
      .tz(props.selectedTimezone)
      .startOf('day')
      .add({
        hour: date.getHours(),
        minutes: date.getMinutes(),
      });
    bookingOption.rangeStartTimeSender = rangeStartTimeSender.valueOf();
    props.updateBookingOption(bookingOptionIndex, bookingOption);
    // setBookingOptionIndex(-1);
    if (props.mentor.mentorDto.scheduleSettingsDto.autoMentorApproval)
      props.moveSchedulingStep(1, true);
    else setS1State(S1_STATES.APPROVE);
  };

  const validTimeRanges =
    props.mentor.mentorDto.scheduleSettingsDto.availableTimeRangesSelector ===
    VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.SPECIFIC_TIME
      ? props.mentor.mentorDto.scheduleSettingsDto.availableTimeRanges || []
      : props.mentor.mentorDto.scheduleSettingsDto
            .availableTimeRangesSelector ===
          VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.NO_TIME
        ? []
        : null;
  const validDateRanges =
    props.mentor.mentorDto.scheduleSettingsDto.availableTimeRangesSelector ===
    VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.SPECIFIC_TIME
      ? props.mentor.mentorDto.scheduleSettingsDto.availableTimeRanges || {}
      : props.mentor.mentorDto.scheduleSettingsDto
            .availableTimeRangesSelector ===
          VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.NO_TIME
        ? {}
        : null;
  return (
    <div className="et-sr-step1">
      {s1State === S1_STATES.DATE ? (
        <>
          <div className="et-sr-s1-sd-top">
            <WidgetTitleComponent
              title={
                props.mentor?.mentorDto.appControlDto.widgetEditableTexts[
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
                ] || context.languageSet.SCHEDULING.LETS_SCHEDULE_MEETING
              }
            />
            {props.mentor.mentorDto.scheduleSettingsDto.autoMentorApproval && (
              <div className="et-sr-s1-session-price-wrap">
                <SessionPriceComponent
                  paymentFlowBasedSessionDto={props.paymentFlowBasedSessionDto}
                />
              </div>
            )}
            <div className="et-sr-s1-datepicker-wrap">
              <DatePickerComponent
                selected={
                  props.bookingOptions[bookingOptionIndex]?.rangeStartTimeSender
                }
                onChange={(date) => setBookingOptionDate(date)}
                onMonthChange={onMonthChange}
                minDate={minDate}
                weekStartDay={
                  props.weekStartDay ||
                  props.mentor.mentorDto.scheduleSettingsDto.weekStartDay
                }
                validTimeRanges={validDateRanges}
                alreadyBookedTimeRanges={props.alreadyBookedTimeRanges}
                timeIntervals={props.timeIntervals}
                timeFormat={
                  props.mentor.mentorDto?.scheduleSettingsDto.timeFormat
                }
                sessionTimeLimit={
                  props.mentor?.sessionTemplateDto?.sessionTimeLimit * 60 * 1000
                }
                scheduleSettingsDto={props.mentor.mentorDto.scheduleSettingsDto}
                selectedTimezone={props.selectedTimezone}
                isLoading={props.isLoading}
                isMentor={props.isMentor}
                widgetLanguageLocaleKey={props.widgetLanguageLocaleKey}
                availableSlotsListsByDate={props.availableSlotsListsByDate}
              />
              <TimeZonePicker
                selectedTimezone={props.selectedTimezone}
                selectTimeZone={selectTimeZone}
                globeColor="var(--et-mentor-cta-btn-primary-background-color-fc)"
              />
            </div>
          </div>
          <div className="et-v2-widget-btn-wrap">
            <ButtonComponent
              type="primary"
              isDisabled={false}
              onClick={() => {
                if (props.isTeamMentor) {
                  const selectedBookingOption =
                    props.bookingOptions[bookingOptionIndex];
                  if (!selectedBookingOption?.rangeStartTimeSender) {
                    const toastObj = utilsService.getToastObj({
                      toastTitle: 'No time slot available',
                      toastType:
                        VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
                    });
                    context.addToastObj(toastObj);
                    return;
                  }
                  // Check if the selected time slot is available in our availableSlotsListsByDate
                  const selectedMoment = moment(
                    selectedBookingOption.rangeStartTimeSender,
                  ).tz(props.selectedTimezone);
                  const dayOfMonth = selectedMoment.format('D');
                  const timeSlot =
                    props.mentor.mentorDto?.scheduleSettingsDto?.timeFormat ===
                    VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
                      ? selectedMoment.format('h:mm A')
                      : selectedMoment.format('HH:mm');

                  const daySlots =
                    props.availableSlotsListsByDate?.[dayOfMonth] || [];
                  const slotAvailable = daySlots.find(
                    (slot) =>
                      slot.time === timeSlot &&
                      slot.availableMentorIds &&
                      slot.availableMentorIds.length > 0,
                  );
                  if (!slotAvailable) {
                    const toastObj = utilsService.getToastObj({
                      toastTitle: 'No time slot available',
                      toastType:
                        VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
                    });
                    context.addToastObj(toastObj);
                    return;
                  }
                }
                setS1State(S1_STATES.TIME);
              }}
              text={context.languageSet.SCHEDULING.NEXT}
            />
          </div>
        </>
      ) : s1State === S1_STATES.TIME ? (
        <>
          {props.isAnonymousPage && (
            <WidgetTitleComponent
              title={context.languageSet.SCHEDULING.LETS_SCHEDULE_MEETING}
            />
          )}
          <ClientBookingOptionRow
            bookingOption={props.bookingOptions[bookingOptionIndex]}
            handleDateClick={() => setS1State(S1_STATES.DATE)}
            handleTimeClick={() => {}}
            handleDelete={() => {}}
            showDelete={false}
            highlightTime={true}
            timeFormat={props.mentor.mentorDto?.scheduleSettingsDto.timeFormat}
            firstAvailableTimeSlot={firstAvailableTimeSlot}
            onDateChanged={onDateChanged}
            showPrevNextBtn={true}
            showEditDeleteBtn={false}
            bookingRowIndForEditDelete={bookingRowIndForEditDelete}
            setBookingRowIndForEditDelete={setBookingRowIndForEditDelete}
            widgetLanguageLocaleKey={props.widgetLanguageLocaleKey}
            selectedTimezone={props.selectedTimezone}
          />
          <div className="et-sr-s1-timepicker-wrap">
            <TimePickerComponent
              selected={
                props.bookingOptions[bookingOptionIndex]?.rangeStartTimeSender
              }
              onChange={(date) => setBookingOptionTime(date)}
              minDate={minDate}
              timeIntervals={props.timeIntervals}
              timeFormat={
                props.timeFormat ||
                props.mentor.mentorDto?.scheduleSettingsDto.timeFormat
              }
              validTimeRanges={validTimeRanges}
              sessionTimeLimit={
                props.mentor?.sessionTemplateDto?.sessionTimeLimit * 60 * 1000
              }
              firstAvailableTimeSlot={firstAvailableTimeSlot}
              setfirstAvailableTimeSlot={setfirstAvailableTimeSlot}
              alreadyBookedTimeRanges={props.alreadyBookedTimeRanges}
              selectedTimezone={props.selectedTimezone}
              mentorTimeZone={
                props.mentor.mentorDto.scheduleSettingsDto.timezone
              }
              isMentor={props.isMentor}
              availableSlotsListsByDate={props.availableSlotsListsByDate}
            />
          </div>
          <div className="et-sr-s1-timezone-wrap">
            <TimeZonePicker
              isDisabled={true}
              selectedTimezone={props.selectedTimezone}
              selectTimeZone={selectTimeZone}
              globeColor="var(--et-mentor-cta-btn-primary-background-color-fc)"
            />
          </div>
          <div className="et-v2-widget-btn-wrap et-sr-s1-footer-btns-wrap">
            <div className="et-sr-s1-prev-btn">
              <ButtonComponent
                type="primary-outlined"
                isDisabled={false}
                onClick={() => setS1State(S1_STATES.DATE)}
                // text={context.languageSet.SCHEDULING.BACK}
                image={
                  <ArrowIcon fillColor="var(--et-mentor-cta-btn-primary-background-color-fc)" />
                }
              />
            </div>
            <ButtonComponent
              type="primary"
              isDisabled={false}
              onClick={() => {
                if (
                  props.mentor.mentorDto.scheduleSettingsDto.autoMentorApproval
                )
                  props.moveSchedulingStep(1, true);
                else setS1State(S1_STATES.APPROVE);
              }}
              text={context.languageSet.SCHEDULING.NEXT}
            />
          </div>
        </>
      ) : s1State === S1_STATES.APPROVE ? (
        <div className="et-sr-s1-approve-wrap">
          {props.isAnonymousPage && (
            <WidgetTitleComponent
              title={context.languageSet.SCHEDULING.LETS_SCHEDULE_MEETING}
            />
          )}
          <div className="et-sr-s1-approve-timezone-wrap">
            <div className="et-sr-s1-options-wrap">
              {props.bookingOptions?.map((alternative, index) => {
                return (
                  <React.Fragment key={index}>
                    <ClientBookingOptionRow
                      index={index}
                      bookingOption={alternative}
                      handleDateClick={popupDatePicker}
                      handleTimeClick={() => {
                        // popupTimePicker(index);
                      }}
                      handleDelete={deleteBookingOption}
                      showDelete={props.bookingOptions.length > 1}
                      timeFormat={
                        props.mentor.mentorDto?.scheduleSettingsDto.timeFormat
                      }
                      firstAvailableTimeSlot={firstAvailableTimeSlot}
                      onDateChanged={onDateChanged}
                      showPrevNextBtn={false}
                      showEditDeleteBtn={true}
                      bookingRowIndForEditDelete={bookingRowIndForEditDelete}
                      setBookingRowIndForEditDelete={
                        setBookingRowIndForEditDelete
                      }
                      selectedTimezone={props.selectedTimezone}
                      widgetLanguageLocaleKey={props.widgetLanguageLocaleKey}
                    />
                    {props.bookingOptions.length > 1 &&
                      props.bookingOptions.length - 1 !== index && (
                        <div className="et-or-text">
                          <div className="et-or-text-bar" />
                          {context.languageSet.INFO_COLLECTOR.OR}
                          <div className="et-or-text-bar" />
                        </div>
                      )}
                    <div
                      className={`et-overlay-container ${
                        bookingRowIndForEditDelete === index
                          ? 'et-show-overlay-container'
                          : 'et-hide-overlay-container'
                      }`}
                      onClick={() => setBookingRowIndForEditDelete(-1)}></div>
                  </React.Fragment>
                );
              })}

              <TimeZonePicker
                isDisabled={true}
                selectedTimezone={props.selectedTimezone}
                selectTimeZone={selectTimeZone}
                globeColor="var(--et-mentor-cta-btn-primary-background-color-fc)"
              />
              {!props.mentor.mentorDto?.scheduleSettingsDto
                .autoMentorApproval &&
                props.bookingOptions?.length <= 2 && (
                  <div
                    className={`et-sr-s1-add-another-row ${
                      props.recipients?.length > 1
                        ? 'et-sr-s1-add-another-row-disabled'
                        : ''
                    }`}
                    onClick={addBookingOption}>
                    <div>
                      <div className="et-plus-wrapper">
                        <div className="et-plus-symbol">{'+'}</div>
                        {context.languageSet.SCHEDULING.ADD_ANOTHER_OPTION}
                      </div>
                      <div className="et-txt-set-options">
                        {props.recipients?.length > 1
                          ? 'Multi-option currently not available with multiple attendees.' //TODO: Ilan -> need to define in languageSet
                          : context.languageSet.SCHEDULING
                              .SET_UPTO_THREE_OPTIONS}
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>{' '}
          <div className="et-v2-widget-btn-wrap et-sr-s1-footer-btns-wrap">
            <div className="et-sr-s1-prev-btn">
              <ButtonComponent
                type="primary-outlined"
                isDisabled={false}
                onClick={() => {
                  setS1State(S1_STATES.TIME);
                }}
                image={
                  <ArrowIcon fillColor="var(--et-mentor-cta-btn-primary-background-color-fc)" />
                }
              />
            </div>
            <ButtonComponent
              type="primary"
              isDisabled={false}
              onClick={() => props.moveSchedulingStep(1, true)}
              text={context.languageSet.SCHEDULING.NEXT}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default SchedulingInWidgetStep1;
